export default __webpack_public_path__ + "7880ed30b038ec913df31e7736e3ef9d.png";